'use client';
import React, {Fragment, useEffect} from 'react';
import {Route, Routes} from 'react-router-dom';
import AppKitProvider from './WagmiProvider';
import DriveRoutes from './drive/drive-routes';
import { ToastContainer } from './ui/toast/toast-container';
import { FullPageLoader } from './ui/progress/full-page-loader';
import { NotFoundPage } from './ui/not-found-page/not-found-page';
import { CommonProvider } from './ui/core/common-provider';

export function AppRoutes() {
  const cookies = document.cookie;
  return (
    <Fragment>
      <CommonProvider>
        <AppKitProvider cookies={cookies}>
          <ToastContainer />
          <Routes>
            <Route
              path="/*"
              element={
                <React.Suspense fallback={<FullPageLoader screen />}>
                  <DriveRoutes />
                </React.Suspense>
              }
            />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </AppKitProvider>
      </CommonProvider>
    </Fragment>
  );
}
